import { FDBox, FDDialog, FDSecondaryActionButton } from '@facet-wealth/design';
import React from 'react';
import PropTypes from 'prop-types';
import Relationship from 'facet-rest/src/domain/Relationship';
import useCollection from 'Hooks/useCollection';
import { useSnackbarContext } from 'Context/SnackbarContext';
import useMobileLayout from 'Hooks/useMobileLayout';
import { MetaResourceRenderer } from 'Components/UI/Meta/MetaForm/Components/MetaResourceRenderer';
import UploadedAccountStatementsLayout
  from 'Components/AdvisorApp/Viewport/MissionControl/Page/Versions/Default/Tabs/Onboarding/Sections/BalanceSheet/UploadedAccountStatementsComponents/Layout';
import uploadedAccountStatementsMetaOverrideSet
  from 'Components/AdvisorApp/Viewport/MissionControl/Page/Versions/Default/Tabs/Onboarding/Sections/BalanceSheet/UploadedAccountStatementsComponents/MetaOverrideSet';

const ReviewAccountStatementButton = ({ relationship }) => {
  const [dialogOpen, setDialogOpen] = React.useState(false);
  const { collection, setCollection } = useCollection();
  const isMobile = useMobileLayout();
  const { displayErrorMessage } = useSnackbarContext();


  if (!relationship) {
    return null;
  }

  const handleButtonClick = async () => {
    try {
      const uploadedAccountStatements = await relationship.link('related').get();
      setCollection(uploadedAccountStatements);
      setDialogOpen(true);
    } catch (e) {
      if (e.errors) {
        displayErrorMessage(e, e.errors);
      } else {
        displayErrorMessage(e, 'Failed to open account statement review');
      }
    }
  };

  return (
    <FDBox>
      <FDSecondaryActionButton
        label={relationship.meta('prompt')}
        onClick={() => handleButtonClick()}
      />
      {/* We are using a dialog here instead of modal context because the mission control tabs are not in page context */}
      <FDDialog
        open={dialogOpen}
        onClose={() => {
          setDialogOpen(false);
        }}
        dialogWidth={'md'}
        color={'subtle'}
        fullScreen={isMobile}
        closeOnBackdropClick
      >
        <MetaResourceRenderer
          key={collection?.resources()?.head()?.type()}
          layout={UploadedAccountStatementsLayout}
          metaOverrideSet={uploadedAccountStatementsMetaOverrideSet}
          resource={collection?.resources()?.head()}
          LayoutProps={{
            setCollection,
          }}
        />
      </FDDialog>
    </FDBox>);
};

ReviewAccountStatementButton.propTypes = {
  relationship: PropTypes.instanceOf(Relationship).isRequired,
};

ReviewAccountStatementButton.defaultProps = {
};

export default ReviewAccountStatementButton;
